import React from 'react';

function EPSalesPages() {
  return (
    <div>EPSalesPages</div>
  );
}

export default EPSalesPages;
